<template>
  <div>
    <v-row>
      <v-col cols="12" class="text-right">
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text class="no-hover hover-primary px-2" @click="toggleFilter()">
              <template v-if="open">
                <v-icon large v-bind="attrs" v-on="on" color="red" class="mr-3">mdi-filter-variant-minus</v-icon> Скрий филтър
              </template>
              <template v-if="!open">
                <v-icon large v-bind="attrs" v-on="on" color="primary" class="mr-3">mdi-filter-variant-plus</v-icon> Покажи филтър
              </template>
            </v-btn>
          </template>
          <span>{{open ? 'Затвори филтъра' : 'Отвори филтъра'}}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row @keypress.enter="doFilter">
      <v-expand-transition>
        <v-col cols="12" v-if="open" class="mb-10">
          <v-form ref="inventoriesFilterForm">
            <base-material-filter
              title="Търсене на артикули"
              :hasFilters="hasActiveFilters"
              v-on:do-filter="doFilter"
              v-on:remove-filter="clearFilters" 
            >
              <v-row @keypress.enter="doFilter" class="mx-1">
                <v-col md="3">
                  <v-text-field 
                    label="Инвентарен номер"
                    v-model="filters.inventoryNumber"
                    autocomplete="off"
                  />
                </v-col>
                <v-col md="3">
                  <v-text-field 
                    label="Заглавие"
                    v-model="filters.name"
                    autocomplete="off"
                  />
                </v-col>
                <v-col md="3">
                  <v-text-field 
                    label="Автор"
                    v-model="filters.author"
                    autocomplete="off"
                  />
                </v-col>
                <v-col md="3">
                  <v-text-field 
                    label="Година на издаване"
                    v-model="filters.publishedDate"
                    autocomplete="off"
                  />
                </v-col>
                <v-col md="3">
                  <v-text-field 
                    label="Сигнатура"
                    v-model="filters.signature"
                    autocomplete="off"
                  />
                </v-col>
                <v-col md="2" cols="12">
                  <base-select
                    :items="properties.availability"
                    item-text="name"
                    item-value="value"
                    v-model="filters.availability"
                    label="Наличност"
                    clearable
                    autocomplete="off"
                  >
                  </base-select>
                </v-col>
              </v-row>
            </base-material-filter>
          </v-form>
        </v-col>
      </v-expand-transition>
    </v-row>
  </div>
</template>

<script>

import { isEmptyObject } from "@/utils";

const filtersModel = Object.freeze({
  name: '',
  author: '',
  inventoryNumber: '',
  publishedDate: '',
  signature: '',
  availability: ''
})

export default {
  name: "inventoryItemsFilter",
  props: {
    postOnClearData: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      open: false,
      properties: {
        availability: [
          {
            name: "Да",
            value: 1
          },
          {
            name: "Не",
            value: 0
          }
        ]
      },
      rules: {},
      filters: Object.assign({}, filtersModel),
      hasActiveFilters: false
    }
  },
  mounted(){},
  methods: {
    toggleFilter(){
      this.open = !this.open;
    },
    doFilter(){
      if(this.$refs.inventoriesFilterForm.validate()){
        if(!isEmptyObject(this.filters) || (isEmptyObject(this.filters))){
          this.filters.page = 1;
          this.hasActiveFilters = true;
          this.$emit("doFilter");
          delete this.filters.page;
        } else {
          if(this.hasActiveFilters === true)
            this.$emit("doFilter");
            
          this.hasActiveFilters = false;
        }
      }
    },
    clearFilters(){
      this.filters = Object.assign({}, filtersModel)

      this.hasActiveFilters = false;

      this.$emit("doFilter", this.postOnClearData);
    },
  }
}
</script>